import React from 'react';
import { motion } from 'framer-motion';

/** Configuration for floating elements */
const ELEMENTS_CONFIG = [
  { left: '20%', top: '10%', size: 40, isCircle: true, duration: 15 },
  { left: '40%', top: '25%', size: 50, isCircle: false, duration: 20 },
  { left: '60%', top: '40%', size: 60, isCircle: true, duration: 25 },
  { left: '80%', top: '55%', size: 70, isCircle: false, duration: 30 },
];

/**
 * MobileFloatingElements Component
 * 
 * Decorative animated shapes for mobile view background.
 * Only visible on mobile (hidden on lg: and up).
 * Uses pointer-events-none to not interfere with interactions.
 * 
 * @example
 * <MobileFloatingElements />
 */
const MobileFloatingElements: React.FC = () => {
  return (
    <div
      className="lg:hidden fixed inset-0 pointer-events-none overflow-hidden"
      aria-hidden="true"
    >
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-haat-red/5 to-transparent" />

      {/* Floating shapes */}
      {ELEMENTS_CONFIG.map((config, index) => (
        <motion.div
          key={index}
          className="absolute opacity-10"
          style={{
            left: config.left,
            top: config.top,
            width: config.size,
            height: config.size,
            border: '2px solid',
            borderColor: config.isCircle ? '#c00035' : '#f8cc05',
            borderRadius: config.isCircle ? '50%' : '20%',
          }}
          animate={{
            rotate: [0, 360],
            y: [0, -20, 0],
          }}
          transition={{
            duration: config.duration,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
};

export default MobileFloatingElements;

